// ACTION TYPES;

//All campuses
export const FETCH_ALL_CAMPUSES = 'FETCH_ALL_CAMPUSES';
export const ADD_CAMPUS = 'ADD_CAMPUS';
export const DELETE_CAMPUS = 'DELETE_CAMPUS';
export const EDIT_CAMPUS = 'EDIT_CAMPUS';

//Single campus
export const FETCH_CAMPUS = 'FETCH_CAMPUS';

//All students
export const FETCH_ALL_STUDENTS = 'FETCH_ALL_STUDENTS';
export const ADD_STUDENT = 'ADD_STUDENT';
export const DELETE_STUDENT = 'DELETE_STUDENT';
export const EDIT_STUDENT = 'EDIT_STUDENT';

//Single student
export const FETCH_STUDENT = 'FETCH_STUDENT';

// Recents
export const FETCH_RECENT_STUDENTS = 'FETCH_RECENT_STUDENTS';
export const FETCH_RECENT_CAMPUSES = 'FETCH_RECENT_CAMPUSES';
